import React from 'react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from '@/components/ui/sheet';
import { ChevronUp, ChevronDown } from 'lucide-react';
import SeverityBadge from './SeverityBadge';

export default function DrawerPanel({
  open, onOpenChange, title, subtitle, severity, children, footer, testId,
  // Optional list navigation props (set by useListDrawer)
  onPrev, onNext, position, total,
}) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        className="w-full sm:max-w-[560px] p-0 flex flex-col bg-white"
        data-testid={testId}
      >
        <SheetHeader className="px-6 py-5 border-b border-slate-200 bg-gradient-to-b from-white to-slate-50/40">
          <div className="flex items-center justify-between gap-3">
            <SheetTitle className="text-[17px] font-semibold text-apex-ink truncate flex-1 min-w-0 leading-tight">{title}</SheetTitle>
            {(onPrev || onNext) && total > 1 && (
              <div className="flex items-center gap-0.5 shrink-0 mr-1" data-testid="drawer-nav">
                <button
                  type="button"
                  onClick={onPrev}
                  data-testid="drawer-prev"
                  title="Previous"
                  className="w-7 h-7 inline-flex items-center justify-center rounded-md border border-slate-200 text-apex-neutral hover:text-apex-ink hover:border-apex-lens hover:bg-white transition-all"
                >
                  <ChevronUp className="w-3.5 h-3.5" />
                </button>
                <span className="text-[11px] font-mono text-apex-neutral tabular px-2" data-testid="drawer-position">
                  {(position ?? 0) + 1} / {total}
                </span>
                <button
                  type="button"
                  onClick={onNext}
                  data-testid="drawer-next"
                  title="Next"
                  className="w-7 h-7 inline-flex items-center justify-center rounded-md border border-slate-200 text-apex-neutral hover:text-apex-ink hover:border-apex-lens hover:bg-white transition-all"
                >
                  <ChevronDown className="w-3.5 h-3.5" />
                </button>
              </div>
            )}
            {severity && <SeverityBadge severity={severity} />}
          </div>
          {subtitle && <SheetDescription className="text-[12px] text-apex-neutral font-mono mt-1.5">{subtitle}</SheetDescription>}
        </SheetHeader>
        <div className="flex-1 overflow-y-auto px-6 py-6 space-y-6">
          {children}
        </div>
        {footer && (
          <div className="px-6 py-4 border-t border-slate-200 bg-slate-50/60 flex flex-wrap gap-2">
            {footer}
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
